import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, DollarSignIcon, FileTextIcon } from 'lucide-react';
export function PainSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="w-full py-20 px-4 bg-navy-light" data-id="element-202">
      <div className="max-w-5xl mx-auto" data-id="element-203">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-204">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-center mb-6" data-id="element-205">
            <span className="text-gold-metallic" data-id="element-206">
              La frustración de ser rechazado
            </span>
            <br data-id="element-207" />
            <span className="text-white" data-id="element-208">que te cierra puertas</span>
          </motion.h2>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-gray-300 text-center mb-16 max-w-3xl mx-auto" data-id="element-209">
            Y el miedo a pagar "reparadores" que no dan resultados.
          </motion.p>

          <motion.div variants={itemVariants} data-id="element-210">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-gold-light text-center mb-12" data-id="element-211">
              Por qué las soluciones antiguas fallan
            </h3>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-212">
            <motion.div variants={itemVariants} className="bg-navy-lighter border border-gold/20 rounded-xl p-6 text-center" data-id="element-213">
              <div className="flex justify-center mb-4" data-id="element-214">
                <DollarSignIcon className="w-12 h-12 text-gold" aria-hidden="true" data-id="element-215" />
              </div>
              <h4 className="text-xl font-heading font-bold text-white mb-3" data-id="element-216">
                Costos Excesivos
              </h4>
              <p className="text-gray-300" data-id="element-217">
                La mayoría cree que necesita gastar{' '}
                <strong className="text-gold-light" data-id="element-218">$500 o más</strong> en
                "asesoría de crédito".
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-navy-lighter border border-gold/20 rounded-xl p-6 text-center" data-id="element-219">
              <div className="flex justify-center mb-4" data-id="element-220">
                <FileTextIcon className="w-12 h-12 text-gold" aria-hidden="true" data-id="element-221" />
              </div>
              <h4 className="text-xl font-heading font-bold text-white mb-3" data-id="element-222">
                Cartas Genéricas
              </h4>
              <p className="text-gray-300" data-id="element-223">
                Muchas agencias solo envían{' '}
                <strong className="text-gold-light" data-id="element-224">cartas genéricas</strong>{' '}
                sin explicar la estrategia real.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-navy-lighter border border-gold/20 rounded-xl p-6 text-center" data-id="element-225">
              <div className="flex justify-center mb-4" data-id="element-226">
                <XCircleIcon className="w-12 h-12 text-gold" aria-hidden="true" data-id="element-227" />
              </div>
              <h4 className="text-xl font-heading font-bold text-white mb-3" data-id="element-228">
                Sin Guía Completa
              </h4>
              <p className="text-gray-300" data-id="element-229">
                No te explican{' '}
                <strong className="text-gold-light" data-id="element-230">el proceso completo</strong>
                : cómo analizar tu reporte, qué errores realmente disputar, qué
                acciones priorizar, cómo estructurar un plan claro.
              </p>
            </motion.div>
          </div>

          <motion.p variants={itemVariants} className="text-xl text-center text-gray-300 mt-12 max-w-3xl mx-auto" data-id="element-231">
            Por eso,{' '}
            <strong className="text-gold-light" data-id="element-232">sin una guía clara</strong>, la
            mejora se estanca.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}